import ReactDOM from 'react-dom/client';
import './index.css';
import './attribution.css';
import 'react-awesome-query-builder/lib/css/styles.css';
import 'react-medium-image-zoom/dist/styles.css';
import App from './core/App';
import { registerSW } from 'virtual:pwa-register';
import { ReloadPrompt } from './components/ReloadPrompt';
import { hotJarConfig } from './core/config';
import { injectContentsquareScript } from '@contentsquare/tag-sdk';

// service worker setup - start
// add this to prompt for a refresh
const updateSW = registerSW({
  onNeedRefresh() {
    const popupElementId = 'sw-refresh';
    ReactDOM.createRoot(document.getElementById(popupElementId)!).render(
      <ReloadPrompt
        onRefresh={() => {
          updateSW(true);
        }}
        onCancel={() => {
          document.getElementById(popupElementId)?.remove();
        }}
      />
    );
  },
});

// https://vitejs.dev/guide/build#load-error-handling
// Vite fails to load dynamic imports
window.addEventListener('vite:preloadError', (event) => {
  event.preventDefault();
  window.location.reload();
});

// NOTE:- Injecting HotJar script
injectContentsquareScript({
  siteId: hotJarConfig[import.meta.env.MODE as keyof typeof hotJarConfig]?.id,
  async: true,
});

// service worker setup - end

ReactDOM.createRoot(document.getElementById('root')!).render(<App />);
